import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function PuffEmbroideryDigitizing() {

    const puffempSteps = [
        { number: "01", title: "Submit Your Design", description: "Send us your logo or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "3D Puff Digitizing", description: "We create a stitch file optimized for foam-based raised embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Optimization", description: "We refine stitch density and coverage for clean, bold results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other formats.", icon: "🚀" }
    ];

    return (
        <>
        
            <Helmet>
                <title>3D Puff Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Specialized 3D puff embroidery digitizing services in Los Angeles, CA. Get bold, raised embroidery designs for caps and apparel. Order today!" />
                <meta name="keywords" content="3d puff embroidery digitizing, puff embroidery digitizing service, 3d puff logo digitizing, hat puff embroidery digitizing, Los Angeles embroidery digitizing, puff digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>3D Puff Embroidery Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>3D Puff Embroidery Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/3dpuff1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Add Dimension to Your Designs</span>
                                <h3 className="case-study-title">3D Puff Embroidery Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in 3D puff embroidery digitizing services in Los Angeles, California, helping businesses create bold, raised embroidery designs that stand out. Unlike standard embroidery, 3D puff digitizing requires a precise approach to stitch density, underlay, and foam coverage to achieve a clean and elevated look.
                                </p>
                                <p className="case-study-description">
                                    Our experienced digitizers carefully structure each design to ensure the foam is properly covered and the edges are sharp and defined. This process is especially important for caps and structured garments where visual impact matters the most. If you're searching for reliable 3D puff embroidery digitizing near you in Los Angeles, Grand Indigo Embroidery delivers high-quality results that enhance the depth and dimension of your designs.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Optimized for Caps, Apparel & Merchandise</span>
                                <h3 className="case-study-title">Custom 3D Puff Logo Digitizing for Caps & Apparel</h3>
                                <p className="case-study-description">
                                    Our 3D puff logo digitizing services are tailored for brands and businesses that want their logos to stand out with a premium, raised finish. We optimize each design for cap embroidery, ensuring the stitching holds the foam properly while maintaining the original shape and proportions of your logo.
                                </p>
                                <p className="case-study-description">
                                    Whether you need bold lettering, simple shapes, or stylized logos, we create files that are ready for production and compatible with all major embroidery machines. Businesses across Los Angeles trust us for consistent quality, fast turnaround, and attention to detail. If you're looking to order 3D puff embroidery digitizing online or need a trusted local expert, Grand Indigo Embroidery ensures your designs achieve maximum visual impact.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/3dpuff2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={puffempSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is 3D puff embroidery digitizing?"
                                    answer="3D puff embroidery digitizing is the process of creating stitch files designed to produce raised embroidery using foam for added depth and dimension."
                                />

                                <FaqItem
                                    question="Do you offer 3D puff embroidery digitizing in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional 3D puff embroidery digitizing services in Los Angeles, California, for both local and online clients."
                                />

                                <FaqItem
                                    question="What types of designs work best for 3D puff embroidery?"
                                    answer="Bold designs, thick lettering, and simple shapes work best for achieving clean and defined 3D puff embroidery results."
                                />

                                <FaqItem
                                    question="Can I order 3D puff embroidery digitizing online?"
                                    answer="Yes, you can easily submit your design and order 3D puff embroidery digitizing online with a fast turnaround."
                                />

                                <FaqItem
                                    question="Is 3D puff embroidery suitable for caps?"
                                    answer="Yes, 3D puff embroidery is most commonly used on caps and hats to create a bold and raised logo appearance."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
